import { infoLog, errorLog } from './logger.js'
const uuid = require('uuid')

function serializeError(error) {
    return {
        message: error.message,
        stack_trace: error.stack_trace
    }
}

export async function timed(action, cb, params) {
    const logger = new TimedLogger(action, params || {})
    logger.start()
    try {
        const response = await cb()
        logger.end()
        return response
    } catch (e) {
        logger.error(e)
        throw e
    }
}

class Timer {
    constructor() {
        this._startTime = new Date()
    }

    durationMillis() {
        return new Date().getTime() - this._startTime.getTime()
    }
}

export class TimedLogger {
    constructor(action, params) {
        this.request_id = uuid.v4(),
        this.action = action
        this.params = params || {}
    }

    async start(additionalParams) {
        this.timer = new Timer()
        await this.log({
            position: "start",
            timing_ms: 0,
            additionalParams: additionalParams || {}
        })
    }

    async error(err) {
        await this.logError(err, this.timer.durationMillis())
    }

    async end(additionalParams) {
        const timing = this.timer.durationMillis();

        await this.log({
            position: "end",
            timing_ms: timing,
            additionalParams: additionalParams || {}
        })
    }

    async log({ position, timing_ms = 0, additionalParams }) {
        await infoLog({
            request_id: this.request_id,
            action: this.action,
            params: { ...this.params, ...additionalParams },
            position,
            timing_ms
        })
    }

    async logError(err, timing_ms) {
        await errorLog({
            request_id: this.request_id,
            action: this.action,
            params: { ...this.params },
            error: serializeError(err),
            timing_ms
        })
    }
}